/**
 * Grammatik's launcher — the shared grammar home, named.
 *
 * Everything structural lives in `src/apps/shared/grammar/AppHome.tsx` so a
 * change to how the course is presented reaches Gramática too.
 */
import { GrammarAppHome } from '../shared/grammar/AppHome';
import type { AppHomeProps } from '../types';

import { grammatikCourse } from './course';

export function AppHome({ appId }: AppHomeProps) {
  return (
    <GrammarAppHome
      appId={appId}
      course={grammatikCourse}
      displayName="Grammatik"
      tagline="One rule a day."
    />
  );
}
